import { useNavigate, useLocation } from "react-router-dom";
import { LineChart, Moon, Sun, LogOut, Users as UsersIcon, Settings as SettingsIcon, KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import { ForcePasswordChange } from "@/components/ForcePasswordChange";

export function Layout({ children }) {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = user?.role === "admin";

  return (
    <div className="min-h-screen bg-background">
      <ForcePasswordChange />
      <header className="sticky top-0 z-40 border-b border-border/60 bg-card/80 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 h-16 flex items-center justify-between">
          <button
            data-testid="brand-home-btn"
            onClick={() => navigate("/")}
            className="flex items-center gap-3 group shrink-0"
          >
            <div className="grid place-items-center h-9 w-9 rounded-lg bg-primary text-primary-foreground">
              <LineChart className="h-5 w-5" />
            </div>
            <div className="text-left hidden sm:block">
              <div className="font-heading font-bold text-base leading-none tracking-tight">Bilancio CEE</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">XBRL Analyst Pro</div>
            </div>
          </button>

          <div className="flex items-center gap-0.5 sm:gap-2 min-w-0">
            {location.pathname !== "/" && (
              <Button variant="ghost" size="sm" className="px-2 sm:px-3" data-testid="nav-dashboard-btn" onClick={() => navigate("/")}>
                Aziende
              </Button>
            )}
            {isAdmin && (
              <>
                <Button variant="ghost" size="sm" className="px-2 sm:px-3" data-testid="nav-users-btn" onClick={() => navigate("/utenti")} aria-label="Utenti">
                  <UsersIcon className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Utenti</span>
                </Button>
                <Button variant="ghost" size="sm" className="px-2 sm:px-3" data-testid="nav-settings-btn" onClick={() => navigate("/impostazioni")} aria-label="Impostazioni Studio">
                  <SettingsIcon className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Impostazioni Studio</span>
                </Button>
              </>
            )}
            <Button variant="ghost" size="icon" data-testid="theme-toggle-btn" onClick={toggle} aria-label="Cambia tema">
              {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
            </Button>
            <div className="hidden sm:block text-xs text-muted-foreground font-mono max-w-[180px] truncate">
              {user?.email}
            </div>
            <ChangePasswordDialog
              trigger={<Button variant="ghost" size="icon" data-testid="change-password-btn" aria-label="Cambia password"><KeyRound className="h-4 w-4" /></Button>}
            />
            <Button variant="outline" size="sm" className="px-2 sm:px-3" data-testid="logout-btn" onClick={logout} aria-label="Esci">
              <LogOut className="h-4 w-4 sm:mr-1.5" /> <span className="hidden sm:inline">Esci</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 py-6 md:py-8">{children}</main>
    </div>
  );
}
